import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const EditPurchasePayment = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [type, setType] = useState("");
  const [amount, setAmount] = useState("");
  const [due, setDue] = useState("");
  const [supplierId, setSupplierId] = useState("");
  const [remarks, setRemarks] = useState("");
  const [suppliers, setSuppliers] = useState([]);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  useEffect(() => {
    axios
      .get(
        `https://dawabajar.encantotech.in/api/purchase-payment-details/${id}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          setType(data.type);
          setAmount(data.amount);
          setDue(data.due);
          setSupplierId(data.supplier_id);
          setRemarks(data.remarks);
        }
      })
      .catch((err) => {
        Toast.fire({
          icon: "error",
          title: "Error fetching payment details",
        });
      });

    axios
      .get("https://api.dawabajar.com/api/get_supplier")
      .then((res) => {
        if (res.data.status === "Success") {
          setSuppliers(res.data.data);
        }
      })
      .catch((err) => {
        Toast.fire({
          icon: "error",
          title: "Error fetching suppliers",
        });
      });
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("type", type);
    data.append("amount", amount);
    data.append("due", due);
    data.append("supplier_id", supplierId);
    data.append("remarks", remarks);

    axios
      .post(
        `https://dawabajar.encantotech.in/api/purchase-payment/update/${id}`,
        data,
        {
          headers: {
            accept: "application/json",
          },
        }
      )
      .then((result) => {
        Toast.fire({
          icon: "success",
          title: result.data.message,
        });
        navigate("/purchase-order-payment");
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: error.response.data.message,
        });
      });
  };

  useEffect(() => {
    if (!localStorage.getItem("status")) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-2 p-0">
            <Sidebar />
          </div>
          <div className="col-sm-10">
            <div className="container-fluid">
              <Navbar />
              <div className="p-2 bg-white">
                <span>
                  <Link to="/dashboard">Dashboard</Link> /{" "}
                  <Link to="/purchase-order-payment">Purchase Payment</Link> / Edit
                </span>
              </div>
              <div className="bg-gre p-60" style={{ minHeight: "570px" }}>
                <div className="main-box">
                  <h5>
                    <center className="mb-4 mt-3">
                      <b>Edit Purchase Payment</b>
                    </center>
                  </h5>
                  <div className="text-box">
                    <Select
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                      displayEmpty
                      className="input-field w-40 mb-3"
                      placeholder="Select Type"
                    >
                      <MenuItem value="" disabled>
                        Select Type
                      </MenuItem>
                      <MenuItem value="cash">Cash</MenuItem>
                      <MenuItem value="online">Online</MenuItem>
                      <MenuItem value="NEFT">NEFT</MenuItem>
                      <MenuItem value="cheque">Cheque</MenuItem>
                    </Select>
                    <TextField
                      id="outlined-basic"
                      label="Amount"
                      variant="outlined"
                      className="input-field w-40 mb-3"
                      type="number"
                      placeholder="Amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                    <TextField
                      id="outlined-basic"
                      label="Due"
                      variant="outlined"
                      className="input-field w-40 mb-3"
                      type="number"
                      placeholder="Due"
                      value={due}
                      onChange={(e) => setDue(e.target.value)}
                    />
                    <Select
                      value={supplierId}
                      onChange={(e) => setSupplierId(e.target.value)}
                      displayEmpty
                      className="input-field w-40 mb-3"
                      placeholder="Select Supplier"
                    >
                      <MenuItem value="" disabled>
                        Select Supplier
                      </MenuItem>
                      {suppliers.map((supplier) => (
                        <MenuItem key={supplier.id} value={supplier.id}>
                          {supplier.head_name}
                        </MenuItem>
                      ))}
                    </Select>
                    <TextField
                      id="outlined-basic"
                      label="Remarks"
                      variant="outlined"
                      className="input-field w-40 mb-3"
                      type="text"
                      placeholder="Remarks"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                    />
                    <button
                      onClick={submitForm}
                      className="btn btn-danger mb-2"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPurchasePayment;
